// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);
}

.layout {
  font-weight: bold;
  padding-left: 50px;
  margin-bottom: 10px;
}

/* Style for the activity-info label */
.activity-info {
  font-style: italic;
  color: #777;
}

/* Buttons */
.btn-primary {
  background: #0B2D71;
  color: #fff;
  border: none;
  border-radius: 0;
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
  font-size: 0.88em;
  cursor: pointer;
}

.btn-primary:hover {
  background: #0066B2;
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/activity-report/activity-report.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,qDAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAGA,sCAAA;AACA;EACE,kBAAA;EACA,WAAA;AAAF;;AAGA,YAAA;AACA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,+EAAA;EACA,iBAAA;EACA,eAAA;AADF;;AAKA;EACE,mBAAA;AAFF","sourcesContent":[".panel {\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 6px 12px rgba(0,0,0,0.1);\n  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);\n}\n\n.layout{\n  font-weight: bold;\n  padding-left: 50px;\n  margin-bottom: 10px;\n}\n\n\n/* Style for the activity-info label */\n.activity-info {\n  font-style: italic;\n  color: #777;\n}\n\n/* Buttons */\n.btn-primary {\n  background:#0B2D71 ;\n  color: #fff;\n  border: none;\n  border-radius: 0;\n \n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';\n  font-size: 0.88em;\n  cursor: pointer;\n // transition: background 0.3s, transform 0.3s;\n}\n\n.btn-primary:hover {\n  background:  #0066B2;\n // transform: translateY(-2px); /* Lift effect on hover */\n}\n\n// .btn-primary:active {\n//   box-shadow: 0 2px #0056b3, 0 0 15px 3px rgba(0, 123, 255, 0.7);\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
